export default "__VITE_ASSET__CR1EQ11j__"